module.exports = __webpack_public_path__ + "img/chanpin3.d2a26558.png";